// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ozsEV","requiredAsterisk":"Info_requiredAsterisk__1isPS"};